<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div>
        <v-icon>mdi-plus</v-icon><span class="headerTitle">{{ labels.hullTitle }}</span>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.vesNo }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.vesName }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.vesDesc }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ hullForm.vesNo }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ hullForm.vesName }}</div>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ hullForm.vesDesc }}</div>
              </v-flex>

              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.issDate }}</v-subheader>
              </v-flex>
              <v-flex xs9>
                <v-subheader class="queryLabel">{{ labels.intCvrd }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ formatDate(hullForm.issDate) }}</div>
              </v-flex>
              <v-flex xs9>
                <div class="queryValue">{{ hullForm.intCvrd }} - {{ hullForm.intCvrdDesc }}</div>
              </v-flex>

              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.imoRefNo }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.chartRefNo }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ hullForm.imoRefNo }}</div>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ hullForm.chartRefNo }}</div>
              </v-flex>

              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.mortgagee }}</v-subheader>
              </v-flex>
              <v-flex xs6> </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ hullForm.mortgagee }}</div>
              </v-flex>
              <v-flex xs6> </v-flex>

              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.yrBuilt }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.vesFlag }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.vesCls }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.vesType }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ hullForm.yrBuilt }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ hullForm.vesFlag }} - {{ hullForm.vesFlagDesc }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ hullForm.vesCls }} - {{ hullForm.vesClsDesc }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ hullForm.vesType }} - {{ hullForm.vesTypeDesc }}</div>
              </v-flex>

              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.grt }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.nrt }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.dwt }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.vesConstn }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ hullForm.grt }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ hullForm.nrt }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ hullForm.dwt }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ hullForm.vesConstn }} - {{ hullForm.vesConstnDesc }}</div>
              </v-flex>

              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.vesOwn }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.vesAgt }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ hullForm.vesOwn }}</div>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ hullForm.vesAgt }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'

export default {
  data() {
    return {
      labels: {
        hullTitle: 'Hull Risk Details',
        vesNo: 'Vessel No.',
        vesName: 'Vessel Name',
        vesDesc: 'Vessel Description',
        issDate: 'Issue Date',
        intCvrd: 'Interest Covered',
        imoRefNo: 'IMO Ref No.',
        chartRefNo: 'Chartered Ref No.',
        mortgagee: 'Mortgagee',
        yrBuilt: 'Year Build',
        vesFlag: 'Vessel Flag',
        vesCls: 'Vessel Class',
        vesType: 'Vessel Type',
        grt: 'Gross Registered Tonnes (GRT)',
        nrt: 'Net Registered Tonnes (NRT)',
        dwt: 'Dead Weight Tonnes (DWT)',
        vesConstn: 'Vessel Construction',
        vesOwn: 'Vessel Owner / Manager',
        vesAgt: 'Vessel Agent / Broker'
      },
      hullForm: {
        vesNo: undefined,
        issDate: undefined,
        intCvrd: undefined,
        intCvrdDesc: undefined,
        vesName: undefined,
        imoRefNo: undefined,
        chartRefNo: undefined,
        mortgagee: undefined,
        vesDesc: undefined,
        vesCls: undefined,
        vesClsDesc: undefined,
        vesType: undefined,
        vesTypeDesc: undefined,
        vesFlag: undefined,
        vesFlagDesc: undefined,
        yrBuilt: undefined,
        grt: undefined,
        nrt: undefined,
        dwt: undefined,
        vesOwn: undefined,
        vesConstn: undefined,
        vesConstnDesc: undefined,
        vesAgt: undefined
      }
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  methods: {
    formatDate(xDate) {
      if (xDate === null || xDate === undefined) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    doInit() {
      this.getPolHullRisk()
    },
    async getPolHullRisk() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.polHullRisk
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.polHullRisk) {
            this.hullForm.vesNo = result.data.polHullRisk.data.vesNo
            this.hullForm.issDate = result.data.polHullRisk.data.issDate
            this.hullForm.intCvrd = result.data.polHullRisk.data.intCvrd
            this.hullForm.intCvrdDesc = result.data.polHullRisk.data.intCvrdDesc
            this.hullForm.vesName = result.data.polHullRisk.data.vesName
            this.hullForm.imoRefNo = result.data.polHullRisk.data.imoRefNo
            this.hullForm.chartRefNo = result.data.polHullRisk.data.chartRefNo
            this.hullForm.mortgagee = result.data.polHullRisk.data.mortgagee
            this.hullForm.vesDesc = result.data.polHullRisk.data.vslDetDto.vesDesc
            this.hullForm.vesCls = result.data.polHullRisk.data.vslDetDto.vesCls
            this.hullForm.vesClsDesc = result.data.polHullRisk.data.vslDetDto.vesClsDesc
            this.hullForm.vesType = result.data.polHullRisk.data.vslDetDto.vesType
            this.hullForm.vesTypeDesc = result.data.polHullRisk.data.vslDetDto.vesTypeDesc
            this.hullForm.vesFlag = result.data.polHullRisk.data.vslDetDto.vesFlag
            this.hullForm.vesFlagDesc = result.data.polHullRisk.data.vslDetDto.vesFlagDesc
            this.hullForm.yrBuilt = result.data.polHullRisk.data.vslDetDto.yrBuilt
            this.hullForm.grt = formatPrice(result.data.polHullRisk.data.vslDetDto.grt)
            this.hullForm.nrt = formatPrice(result.data.polHullRisk.data.vslDetDto.nrt)
            this.hullForm.dwt = formatPrice(result.data.polHullRisk.data.vslDetDto.dwt)
            this.hullForm.vesOwn = result.data.polHullRisk.data.vslDetDto.vesOwn
            this.hullForm.vesConstn = result.data.polHullRisk.data.vslDetDto.vesConstn
            this.hullForm.vesConstnDesc = result.data.polHullRisk.data.vslDetDto.vesConstnDesc
            this.hullForm.vesAgt = result.data.polHullRisk.data.vslDetDto.vesAgtDesc
          }

          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyQuerySettings.init !== 1) {
      this.$store.dispatch('policyQueryInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
